
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Натиснете „Отваряне в браузър…“`,
's182ab2d6c997515f': `Добавете го към началния си екран за по-добро преживяване и лесен достъп.`,
's224cbcec014ef6b5': `Натиснете „Сподели“ в лентата за навигация.`,
's233af3b7eb5e0364': `Добави към началната страница`,
's37a9e8aec5713460': `Разшири`,
's4c3161035f3a1413': `Натиснете менюто`,
's4e1e10a6ca408245': `Натиснете „Добави към началния екран“`,
's6196153c4b0c1ea0': `Инсталирайте`,
's633502f7cff4f847': `Отворете менюто на браузъра си`,
's681e399d63311fba': `Покажи галерия`,
's6d14a4f70ba4e3cf': `Натиснете менюто, ако няма икона „Сподели“`,
's922329d6f6213590': `Добави към Dock`,
's9c63a79ffcc2a3a3': `Натиснете „Добави към началния екран“`,
'sa2d71bfd9525168d': `Натиснете „Добави към Dock“`,
'sa5ef80b4bb9b39f8': `Свий`,
'sb527eca1c1d7e7be': `Отворете менюто на вградения браузър`,
'sba52286c21552a4e': `Инсталирайте го на вашето устройство за по-пълноценно изживяване и по-лесен достъп.`,
'sc16e00a7a8b2fde2': `Назад`,
'scdaf4bbff76674c8': `Добави към началния екран`,
'sd18a5b85f599ff3c': `Отворете копираната връзка в Safari`,
'se72fc3a84f9b51c3': `Докоснете, за да копирате връзката`,
'se740f75b95a51807': `Добавете го към Dock за по-пълноценно преживяване и по-лесен достъп.`,
'sfa6c42cdf48d93d2': `Но този браузър не го поддържа. Отворете връзката във външен браузър, за да продължите.`,
'sfb78526365796a41': `Натиснете „Преглед на още“ в менюто „Сподели“`,
'sfea652f6580ff086': `Този сайт работи като приложение.`,
    };
  